import React from 'react';
import { FaRegClock, FaCalendar, FaUser, FaSearch } from 'react-icons/fa'; // Example icons from react-icons
import './styles.css';  // Import the styles you created

// IconCard Component
const IconCard = ({ icon, title, onClick }) => (
  <div className="card" onClick={onClick}>
    <div className="icon">{icon}</div>
    <span>{title}</span>
  </div>
);

// IconGrid Component
const IconGrid = () => {
  // Navigate to a direct URL when the card is clicked
  const handleCardClick = (url) => {
    window.open(url, '_blank'); // This will open the URL in a new tab
  };
  

  return (
    <div className="grid-container">
      <IconCard
        icon={<FaRegClock />}
        title="CVS Health"
        onClick={() => handleCardClick('https://heartbeat.cvshealth.com/')} // Example URL
      />
      <IconCard
        icon={<FaCalendar />}
        title="Workfront"
        onClick={() => handleCardClick('https://cvshealth.my.workfront.com/')} // Another example URL
      />
      <IconCard
        icon={<FaUser />}
        title="PLP SKU"
        onClick={() => handleCardClick('https://prod-fs.cvs.com/')}
      />
      <IconCard
        icon={<FaUser />}
        title="Contentful"
        onClick={() => handleCardClick('https://app.contentful.com/')}
      />
      <IconCard
        icon={<FaUser />}
        title="Drive"
        onClick={() => handleCardClick('https://aetnao365.sharepoint.com/')}
      />
      <IconCard
        icon={<FaUser />}
        title="Desktop Html Converter"
        onClick={() => handleCardClick('https://creativeapp.sebpo.net/banner/test/cmx/html-formatter/index.html')}
      />
      <IconCard
        icon={<FaUser />}
        title="Mobile Html Converter"
        onClick={() => handleCardClick('https://creativeapp.sebpo.net/banner/test/cmx/html-formatter/mobile-app.html')}
      />
      <IconCard
        icon={<FaUser />}
        title="SkU Download"
        onClick={() => handleCardClick('https://internal-prod-ecomm.cvshealth.com/cvs/digital/catalog-feed-generator/skuReport')}
      />
      <IconCard
        icon={<FaUser />}
        title="GAM"
        onClick={() => handleCardClick('https://admanager.google.com/')}
      />
      <IconCard
        icon={<FaSearch />}
        title="Data Search"
        onClick={() => handleCardClick('https://creativeapp.sebpo.net/data-search')}
      />
      <IconCard
        icon={<FaSearch />}
        title="Alta Text"
        onClick={() => handleCardClick('https://creativeapp.sebpo.net/banner/test/cmx/alt-generator.html')}
      />
      {/* Add more IconCard components with direct URLs */}
    </div>
  );
};

// Home Component
export default function Home() {
  return (
    <div>
      <h1>Home Page</h1>
      <IconGrid /> {/* Add the IconGrid here */}
    </div>
  );
}
